
import { useNavigate, useLocation } from "react-router-dom";
import { 
  BarChart, Home, Inbox, FileText, Settings, 
  Server, Activity, LogOut, User, Mail, CreditCard
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { 
  Sidebar as SidebarComponent, 
  SidebarContent, 
  SidebarFooter, 
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarTrigger
} from "@/components/ui/sidebar";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut, tenantType } = useAuth();
  
  const tenantNavItems = [
    {
      icon: Home,
      label: "Dashboard",
      path: "/dashboard",
    },
    {
      icon: Mail,
      label: "Mailboxes / Rules",
      path: "/mailboxes",
    },
    {
      icon: FileText,
      label: "Templates",
      path: "/templates",
    },
    {
      icon: BarChart,
      label: "Analytics",
      path: "/analytics",
    },
    {
      icon: CreditCard,
      label: "Billing",
      path: "/billing",
    },
  ];

  const adminNavItems = [
    {
      icon: Server,
      label: "System Dashboard",
      path: "/ops",
    },
    {
      icon: Activity,
      label: "Event Logs",
      path: "/ops/events",
    },
  ];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <SidebarComponent>
      <SidebarHeader>
        <div className="flex items-center gap-2 px-2 py-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-md">
            <img src="/favicon-324.png" alt="AutoReply365" className="h-8 w-8" />

          </div>
        <span className="text-lg font-semibold text-primary">AutoReply365</span>
        </div>
      </SidebarHeader>
      
      <SidebarContent>
        {tenantType === "tenant" && (
          <SidebarGroup>
            <SidebarGroupContent>
              <SidebarMenu>
                {tenantNavItems.map((item) => (
                  <SidebarMenuItem key={item.path}>
                    <SidebarMenuButton 
                      isActive={isActive(item.path)}
                      onClick={() => navigate(item.path)}
                      tooltip={item.label}
                    >
                      <item.icon className="h-4 w-4" />
                      <span className="">{item.label}</span>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}
        
        {tenantType === "admin" && (
          <>
            <SidebarGroup>
              <SidebarGroupLabel>Admin Portal</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {adminNavItems.map((item) => (
                    <SidebarMenuItem key={item.path}>
                      <SidebarMenuButton 
                        isActive={isActive(item.path)}
                        onClick={() => navigate(item.path)}
                        tooltip={item.label}
                      >
                        <item.icon className="h-4 w-4" />
                        <span>{item.label}</span>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  ))}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
            
            <SidebarGroup>
              <SidebarGroupLabel>Tenant Access</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {tenantNavItems.map((item) => (
                    <SidebarMenuItem key={item.path}>
                      <SidebarMenuButton 
                        isActive={isActive(item.path)}
                        onClick={() => navigate(item.path)}
                        tooltip={item.label}
                      >
                        <item.icon className="h-4 w-4" />
                        <span>{item.label}</span>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  ))}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          </>
        )}
      </SidebarContent>
      
      <SidebarFooter>
      <div className="px-2 md:hidden">
          <SidebarTrigger />
        </div>
      </SidebarFooter>
    </SidebarComponent>
  );
}
